//sending details to BE for paylod fetch
export const MPIN_LOGIN_SUCCESS = "MPIN_LOGIN_SUCCESS"
export const MPIN_LOGIN_ERROR = "MPIN_LOGIN_ERROR"
export const MPIN_LOGIN_RESET = "MPIN_LOGIN_RESET"